export interface LegalLinks {
  readonly terms: string;
  readonly privacy: string;
}

/** OWN-376: terms / privacy live on the customer pages host; no host configured → same-origin paths. */
export function legalLinks(base: string = import.meta.env.VITE_PAGES_BASE_URL ?? ""): LegalLinks {
  const root = base.replace(/\/+$/, "");
  return { terms: `${root}/terms`, privacy: `${root}/privacy` };
}
